module.exports = __webpack_public_path__ + "img/trash.2af16b29.svg";